import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../components/modal/Modal';
import Button from '../../../components/button/Button';
import TextField from '../../../components/textField/TextField';
import Icon from '../../../components/icon/Icon';
import LoadingOverlay from '../../../components/loadingOverlay/LoadingOverlay';
import styles from './Icd10FormModal.module.scss';

const Icd10FormModal = ({ onClose, onSubmit, isLoading, initialData }) => {
  const isEditMode = !!initialData;
  const [form, setForm] = useState({ code: '', shortDescription: '', longDescription: '' });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialData) {
      setForm({
        code: initialData.code || '',
        shortDescription: initialData.shortDescription || '',
        longDescription: initialData.longDescription || '',
      });
    }
  }, [initialData]);

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
    setErrors(prev => ({ ...prev, [field]: null }));
  };

  const handleSubmit = () => {
    const newErrors = {};
    if (!form.code.trim()) newErrors.code = 'Code is required';
    if (!form.shortDescription.trim()) newErrors.shortDescription = 'Short description is required';
    if (!form.longDescription.trim()) newErrors.longDescription = 'Long description is required';
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    onSubmit(form);
  };

  return (
    <Modal>
      {isLoading && <LoadingOverlay />}
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>{isEditMode ? 'Edit ICD-10 Code' : 'Add ICD-10 Code'}</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            <Icon name="plus" />
          </button>
        </div>
        <div className={styles.divider} />
        <div className={styles.form}>
          <TextField
            label="Code"
            value={form.code}
            placeholder="e.g. A00.0"
            onChange={(value) => handleChange('code', value)}
            error={errors.code}
          />
          <TextField
            label="Short Description"
            value={form.shortDescription}
            placeholder="Enter short description"
            onChange={(value) => handleChange('shortDescription', value)}
            error={errors.shortDescription}
          />
          <TextField
            label="Long Description"
            value={form.longDescription}
            placeholder="Enter long description"
            onChange={(value) => handleChange('longDescription', value)}
            error={errors.longDescription}
          />
        </div>
        <div className={styles.actions}>
          <Button label="Cancel" variant="cancel" size="small" onClick={onClose} />
          <Button
            label={isEditMode ? 'Save Changes' : 'Add ICD-10'}
            variant="primary"
            size="small"
            onClick={handleSubmit}
            isLoading={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
};

Icd10FormModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  initialData: PropTypes.shape({
    code: PropTypes.string,
    shortDescription: PropTypes.string,
    longDescription: PropTypes.string,
  }),
};

export default Icd10FormModal;
